var DateSelectorDay = (function (_classes, _eventHandler, _dsEventHandler) {
    var templateName = 'date-picker-days';
    var $el = $('<div role="daySelector" class="date-selector-table date-selector-table__content">');

    var currentDay;

    var _getMaxDayInMonth = function (month, year) {
        var max = 31;
        var date = new Date(year, month, max);

        while (date.getMonth() !== month) {
            var day = new Date(date).getDate();
            date.setDate(day - 1);
        }

        return date.getDate();
    };

    var _getDaysInMonth = function (month, year) {
        var date = new Date(year, month, 1);
        var days = [];
        while (date.getMonth() === month) {
            var day = new Date(date).getDate();
            days.push({ Day: day, DayString: _dayToString(day) });
            date.setDate(day + 1);
            maxDayInMonth = day;
        }

        while (days.length % 7 !== 0) {
            days.push(null);
        }
        return days;
    }

    var _changeDay = function (day) {
        if (currentDay !== day) {
            currentDay = day;
            $el.find('.' + _classes.selectedCell).removeClass(_classes.selectedCell);
            $el.find('@dayCell[data-value="' + currentDay + '"]').addClass(_classes.selectedCell);
        }
    }

    var _subscribe = function () {
        $el.find('@dayCell').on('click', function () {
            var day = $(this).data('value');

            _changeDay(day);

            _eventHandler.trigger('changeDay', currentDay);
        });
    };

    _eventHandler.on('changeDay', function (e, day) {
        _changeDay(day);
    });

    var _dayToString = function (day) {
        return day.toString().replace(/^(\d)$/, '0$1');
    }

    var _isValid = function (month, year) {
        return month !== null && year !== null && month !== undefined && year !== undefined;
    }

    var _render = function () {
        var _days = [];

        for (var i = 1; i <= 31; i++) {
            _days.push({ Day: i, DayString: _dayToString(i) });
        }

        $el.html($.tmpl(templateName, { Days: _days }));
        if (currentDay) {
            $el.find('@dayCell[data-value="' + currentDay + '"]').addClass(_classes.selectedCell);
        }
        _subscribe();
    }

    return {
        init: function (month, year) {
            _render(month, year);
            _dsEventHandler.onDisplay(function (e, display) {
                _render();
                $el.toggleClass(_classes.hidden, display !== 'days');
            });
        },
        appendTo: function ($container) {
            $container.append($el);
        },
        updateDay: function (month, year) {
            var maxDay = _isValid(month, year) ? _getMaxDayInMonth(month, year) : 31;

            if (currentDay > maxDay) {
                currentDay = maxDay;
                _eventHandler.trigger('changeDay', currentDay);
            }
        },
        setDay: function (value) {
            _changeDay(value);
            return value;
        },
        onChange: function (func) {
            _eventHandler.on('changeDay', func);
        }
    }
});